var React = require('react');

function Connect180 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 1000C0 448.617 453.074 0 1010 0L1010 579.819V666.667C824.077 666.667 673.355 815.906 673.355 1000L0 1000Z","fill":"currentColor"}));
}

Connect180.defaultProps = {"width":"1010","height":"1000","viewBox":"0 0 1010 1000","fill":"none"};

module.exports = Connect180;

Connect180.default = Connect180;
